//测试支付接口host https://dev2payment.happyelements.com
//线上支付接口host https://webpay2.happyelements.cn
var Payment = xClass("HuaweiQuickgamePaymentNew")
Payment.prototype.ctor = function () {

}

Payment.prototype.errCodeToMsg = function (errCode = "") {
    //TODO:vivom没有错误码说明文档，暂时统一返回支付失败提示
    let msg = "支付失败";
    switch (errCode) {
        case 60000:
            msg = "支付取消";
            break;
        case 100: //支付api返回数据异常
        case 101: //发货重试超限制
        case 102: //校验订单错误
        case 103: //校验订单接口错误
            msg = "支付失败 " + errCode
            break;
        default:
            break;
    }
    return msg;
}
// 获取失败类型
Payment.prototype.getFailType = function (errCode) {
    let fail_type = 1;
    if (errCode == 0) { //取消支付
        fail_type = -1;
    }
    return fail_type;
}
Payment.prototype.getPayConfigHW = function () {
    return UserManager.getInstance().getPayConfigHW()
    // return{
    //     applicationID: "106938495",
    //     publicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAptMHFafAM9+dNgGbup1pCCBwK5VqOiFjYUFQDZuL6r2wx1qWYw737MILEypVBufGZObIuvqLsiHbOiOAC/vLwyvK+C2B1KcGizsRAEGmArIujK58uKSdaCxrn277dTwHaKmMyjRt0X0Nr2iIJzHg1A0+WK0EUZPn+HvR+gusDhYx/pjH50ryUDcL0e1I/b6OgIjLIl4yIarhWFQa4L5rcf3AqYkyYpiFWFx2djSjzY4WgI41KKDG2gEqEoOOlQwnakRCsTh4KZpXC2NsDBpRLnEBfiOuF2r2SAqclW4tKxFWApa3xiHtp5BQD4wV2HvvELrhUG1DhF0hnnBJbJf1yQIDAQAB"
    // }
}
Payment.prototype.buy = function (data, successCallback, failCallback, closeCallback) {
    let self = this

    console.warn("[HW_PAY]call huawei buy data:" + JSON.stringify(data))
    let productId = data.productId

    function onSuccess(resp) {
        let data = resp.data
        // console.log("[################]getinfohttp success")
        // let orderId = data.orderId;
        // let balance = data.balance
        // let cash = data.cash
        console.log("[HW_PAY]huawei pay data ", JSON.stringify(data))
        // console.log("[HW_PAY]huawei pay data orderInfo ", decodeURIComponent(data.orderInfo))
        console.log("[HW_PAY]huawei pay data.orderId ", data.orderId)
        console.log("[HW_PAY]huawei pay productId ", productId)
        let payConfig = self.getPayConfigHW()
        // productId = "test14"
        let params = {
            purchaseIntentReq: {
                // 替换成真实有效的APP ID
                applicationID: payConfig.applicationID,
                // 替换成AGC控制台的消耗型商品ID
                productId: productId,
                priceType: 0,
                developerPayload: data.orderId,
                // 替换成真实有效的支付公钥
                publicKey: payConfig.publicKey
            }
        }
        HwFastappObject.createPurchaseIntent(JSON.stringify(params))
        HwFastappObject.onCreatePurchaseIntentResult = function onCreatePurchaseIntentResult(str) {
            console.log("[HW_PAY]", "onCreatePurchaseIntentResult =" + JSON.stringify(str))
            // console.log("[HW_PAY]", "onCreatePurchaseIntentResult str.code ", str.code)
            // alert('onCreatePurchaseIntentResult:' + JSON.stringify(str))
            if (str.code == 0) {
                console.log("[HW_PAY] pay success")
                let appData = JSON.parse(str.data)
                if (appData.inAppPurchaseData) {
                    // purchaseToken
                    self.requestDeliverGoods({
                        inAppPurchaseDatas: [
                            appData.inAppPurchaseData
                        ],
                        inAppDataSignatures: [
                            appData.inAppDataSignature
                        ]
                    }, () => {
                        // 这里依据服务端发货，订单状态仅做消耗处理不需要等待订单消耗完成
                        console.log("[HW_PAY]onCreatePurchaseIntentResult inAppPurchaseData =",inAppPurchaseData)
                        if (appData.inAppPurchaseData){
                            let inAppPurchaseData = JSON.parse(appData.inAppPurchaseData)
                            if (successCallback) {
                                successCallback({
                                    orderId: data.orderId
                                })
                            }
                            // 消耗订单
                            self.consumeOwned(inAppPurchaseData.purchaseToken)
                        }else{
                            failCallback({
                                code: -1,
                                data: self.errCodeToMsg(-1),
                                msg: self.errCodeToMsg(-1),
                            })
                        }
                        // if (window.hw_test_pay){
                        // }else{
                        //     console.log("[HW_PAY] 模拟丢单")
                        //     window.hw_test_pay = true
                        // }
                    }, (evt) => {
                        let code = -1
                        if (evt && evt.code) code = evt.code
                        console.log("[HW_PAY] code",code)
                        failCallback({
                            code: code,
                            data: self.errCodeToMsg(code),
                            msg: self.errCodeToMsg(code),
                        })
                    })
                } else {
                    failCallback({
                        code: -1,
                        data: self.errCodeToMsg(-1),
                        msg: self.errCodeToMsg(-1),
                    })
                }
            } else if (str.code == 60051 || str.code == -1) {
                // let appData = JSON.parse(str.data)
                console.log("[HW_PAY] pay fail 尝试检查补单")
                self.payStatusCheck(()=>{
                    if (successCallback) {
                        successCallback({
                            orderId: data.orderId
                        })
                    }
                }, ()=>{
                    failCallback({
                        code: -1,
                        data: self.errCodeToMsg(-1),
                        msg: self.errCodeToMsg(-1),
                    })
                })
            } else {
                console.log("[HW_PAY] pay canel 支付取消 ", self.errCodeToMsg(str.code))
                failCallback({
                    code: -1,
                    data: self.errCodeToMsg(str.code),
                    msg: self.errCodeToMsg(str.code),
                })
            }
        }
    }

    function onFail(evt) {
        cc.log("[HW_PAY]getinfohttp failed" + JSON.stringify(evt))
        let errcode = evt ? evt.data : -1;
        failCallback({
            code: errcode,
            data: "初始化订单失败"
        })
    }

    function onCancel() {
        console.log("[################]getinfohttp canecel")
        failCallback({
            code: -1,
            data: "初始化订单取消"
        })
    }

    let http = HuaweiQuickgamePaymentGetInfoV2Http.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load({
        productId: productId,
        openid: META.user.openid,
        zoneId: META.user.serverid || 1, //android
        sessionid: META.user.sessionid,
        serverId: META.user.serverid,
        ext: data.ext

    })
}
// 请求发货
Payment.prototype.requestDeliverGoods = function (data, successCb, failCb, noRetry) {
    let self = this
    console.log("[HW_PAY] requestDeliverGoods", JSON.stringify(data))
    // let loadId = LoadingPanelLogic.getInstance().add("购买中，请耐心等待...", () => {
    //     LoadingPanelLogic.getInstance().remove(loadId)
    // })
    if (!data || !data.inAppPurchaseDatas) {
        failCb && failCb({code:100});
        return
    }
    let realDeliver = () => {
        let orderList = []
        for (let i = 0; i < data.inAppPurchaseDatas.length; i++) {
            let purchaseData = data.inAppPurchaseDatas[i]
            // console.log("[HW_PAY] requestDeliverGoods purchaseData ", purchaseData)
            JSON.parse(purchaseData).orderId
            let orderId = JSON.parse(purchaseData).orderId
            // console.log("[HW_PAY] requestDeliverGoods .orderId ", orderId)
            // orderId
            orderList.push(orderId)
        }
        console.log("[HW_PAY] requestDeliverGoods orderList ", orderList)

        let http = QueryThirdPartyOrderHttp.new();
        let retryMax = 5; //重试上限 
        let retryNum = 0;
        let retryInterval = 1; //重试间隔
        let retryFunc = () => {
            retryNum++;
            if (retryNum > retryMax) {
                // LoadingPanelLogic.getInstance().remove(loadId)
                failCb && failCb({code:101});
                return;
            }
            setTimeOut(() => {
                http.load(orderList);
            }, retryInterval)
        }
        let onSuccess = (evt) => {
            console.log("[HW_PAY] realDeliver onSuccess ", JSON.stringify(evt.data))
            if (evt.data && evt.data.status) {
                let status = $tableToArray(evt.data.status)
                console.log("[HW_PAY] realDeliver onSuccess status ", JSON.stringify(status))
                let isDeliver = false //是否发货 有一个状态为true就给发货
                for (let i = 0; i < status.length; i++) {
                    if (isDeliver) break
                    isDeliver = status[i]
                }
                if (status.length > 1){
                    Toast.make(getText("当前部分奖励发放异常,请登录后重试"))
                }
                console.log("[HW_PAY] realDeliver onSuccess isDeliver ", isDeliver)
                console.log("[HW_PAY] realDeliver onSuccess noRetry ", noRetry)
                // isDeliver = true //测试一下
                if (isDeliver || noRetry) {
                    // LoadingPanelLogic.getInstance().remove(loadId)
                    successCb && successCb(isDeliver)
                } else {
                    retryFunc()
                }
            } else {
                retryFunc()
            }
        }
        let onFail = (evt) => {
            console.log("[HW_PAY] realDeliver onFail ", JSON.stringify(evt))
            retryFunc();
        }

        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load(orderList);
    }
    // 先检查订单
    self.checkOrder(data, () => {
        realDeliver()
    }, (evt) => {
        // LoadingPanelLogic.getInstance().remove(loadId)
        failCb && failCb(evt)
    })
}
Payment.prototype.checkOrder = function (data, successCb, failCb) {
    let self = this
    let onSuccess = (evt) => {
        console.log("[HW_PAY] checkOrder ", JSON.stringify(evt))
        console.log("[HW_PAY] checkOrder extractResult ", evt.data.extractResult)
        if (evt.data.extractResult == 0) {
            successCb && successCb()
        } else {
            failCb && failCb({code:102})
        }
    }
    let onFail = (evt) => {
        failCb && failCb({code:103})
    }
    let http = HuaweiCheckOrderHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onFail)
    // let inAppPurchaseDataList = []
    // for (let i = 0; i < data.inAppPurchaseDatas.length; i++) {
    //     inAppPurchaseDataList.push(JSON.stringify(data.inAppPurchaseDatas[i]))
    // }
    console.log("[HW_PAY] checkOrder inAppPurchaseDatas ", JSON.stringify(data.inAppPurchaseDatas))

    http.load({
        openid: META.user.openid,
        zoneId: META.user.serverid || 1, //android
        inAppPurchaseData: data.inAppPurchaseDatas,
        dataSignature: data.inAppDataSignatures
    })
}


// 消耗订单
Payment.prototype.consumeOwned = function (purchaseToken) {
    console.log("[HW_PAY] consumeOwned purchaseToken ", purchaseToken)
    let self = this
    let payConfig = self.getPayConfigHW()
    let params = {
        consumeOwnedPurchaseReq: {
            "applicationID": payConfig.applicationID,
            "developerPayload": "testPurchase",
            "purchaseToken": purchaseToken,
            "publicKey": payConfig.publicKey,
        }
    }
    HwFastappObject.consumeOwnedPurchase(JSON.stringify(params));
    HwFastappObject.onConsumeOwnedPurchaseResult = function onConsumeOwnedPurchaseResult(str) {
        // let appData = JSON.parse(str.data)
        if (str.code === 0) {
            console.log("[HW_PAY] Consume success")
            return
        }
        if (str.code === 60053) {
            console.log("[HW_PAY] Goods have been consumed and cannot be consumed again")
        } else {
            console.log("[HW_PAY] Consume fail")
        }
    }
}

Payment.prototype.obtainOwned = function (successCallback) {
    let self = this
    console.log("[HW_PAY] obtainOwned ")
    let payConfig = self.getPayConfigHW()
    let params = {
        ownedPurchasesReq: {
            priceType: 0,
            applicationID: payConfig.applicationID,
            publicKey: payConfig.publicKey
        }
    }
    HwFastappObject.obtainOwnedPurchases(JSON.stringify(params))
    HwFastappObject.onObtainOwnedPurchasesResult = function onObtainOwnedPurchasesResult(str) {
        // alert('onObtainOwnedPurchasesResult:' + JSON.stringify(str))
        let appData = JSON.parse(str.data)
        inAppPurchaseData = appData.inAppPurchaseDataList
        console.log("[HW_PAY] onObtainOwnedPurchasesResult ", JSON.stringify(appData))
        successCallback(appData)
    }
}
// 检查是否需要补单 这里服务端返回需要发货才会执行successCallback 其余执行failCallback
// 简单的消耗订单状态没必要让用户感知
Payment.prototype.payStatusCheck = function (successCallback, failCallback) {
    let self = this
    // Toast.make("开始检查是否需要补单20")
    console.log("[HW_PAY] payStatusCheck 1 ")
    self.obtainOwned((appData) => {
        console.log("[HW_PAY] payStatusCheck appData ", JSON.stringify(appData))
        if (appData && appData.inAppPurchaseDataList) {
            let inAppPurchaseDataList = appData.inAppPurchaseDataList
            console.log("[HW_PAY] payStatusCheck inAppPurchaseDataList ",JSON.stringify(inAppPurchaseDataList))
            console.log("[HW_PAY] payStatusCheck appData.inAppSignature ",JSON.stringify(appData.inAppSignature))
            // let cnt = 0
            self.requestDeliverGoods({
                inAppPurchaseDatas: inAppPurchaseDataList,
                inAppDataSignatures: appData.inAppSignature
            }, (isDeliver) => {
                console.log("[HW_PAY] payStatusCheck isDeliver ", isDeliver)
                successCallback && successCallback()
                if(!successCallback && isDeliver){
                    Toast.make(getText("当前部分奖励发放异常,请登录后重试"))
                }
            }, () => {
                failCallback && failCallback()
            }, true)

            // let successCb = () => {}
            // let failCb = () => {}
            for (j = 0, len = inAppPurchaseDataList.length; j < len; j++) {
                var purchaseToken = JSON.parse(inAppPurchaseDataList[j]).purchaseToken
                self.consumeOwned(purchaseToken)
            }
        }
    })
}

module.exports = Payment